import { cachePages, dightExp, pruneCacheEntry, pruneCache } from "./keepUtils";
function isDef(v) {
  return v !== undefined && v !== null;
}

function getFirstComponentChild(children) {
  if (Array.isArray(children)) {
    for (let i = 0; i < children.length; i++) {
      const c = children[i];
      if (isDef(c) && isDef(c.componentOptions)) {
        return c;
      }
    }
  }
}

export default {
  name: "m-keepalive",
  data() {
    return {};
  },
  abstract: true,

  props: {
    isDestroy: Boolean,
  },

  created() {
    this.cache = cachePages;
  },

  destroyed() {
    for (const key in this.cache) {
      pruneCacheEntry(this.cache[key]);
    }
  },
  watch: {
    $route(to, from) {
      if (from.fullPath == to.fullPath) return;
      // console.log(`${this.isDestroy} ${from.fullPath}`);
      if (this.isDestroy) {
        const cacheName = from.fullPath.replace(dightExp, "");
        this.$nextTick(() => {
          pruneCache(this.cache, this._vnode, name => name != cacheName);
        });
      }
    },
  },

  render() {
    const vnode = getFirstComponentChild(this.$slots.default);
    const componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      const key = this.$route.fullPath.replace(dightExp, "");
      if (this.cache[key]) {
        vnode.componentInstance = this.cache[key].componentInstance;
      } else {
        this.cache[key] = vnode;
      }
      vnode.data.keepAlive = true;
    }
    return vnode;
  },
};
